export default (text) => text.replace(/<text\/>/ig, '');
